<template>
  <SsoButton
    buttonText="Log in with Google"
    imageUrl="sso_icon.svg"
    @ssoButtonClicked="handleGoogleSignIn"
  ></SsoButton>
</template>

<script>
  import loginSsoService from '../../services/LoginSsoService';
  import SsoButton from '../guest/SsoButton.vue';

  export default {
    name: 'GoogleSsoSignIn',
    components: {
      SsoButton,
    },
    methods: {
      handleGoogleSignIn() {
        dataLayer.push({
          event: 'loginwithgooglebtn',
          omuserid: 'systemuserid',
        });
        if (this.gisLoaded) {
          const client = google.accounts.oauth2.initTokenClient({
            client_id: this.whitelabel.sso.googleClientId,
            scope:
              'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
            callback: this.handleCredentialResponse,
          });

          client.requestAccessToken();
        } else {
          console.error('Google Identity Services library is not loaded yet.');
        }
      },
      handleCredentialResponse(response) {
        this.authenticate(response.access_token);
      },
      authenticate(token) {
        loginSsoService
          .login(token, 'Google SSO', this.$apollo, this.$store)
          .then(result => {
            if (result.message?.includes('GraphQL error')) {
              console.log('Error:', result.message);
              throw result;
            }
            loginSsoService.loginSuccess(
              result.data.loginSso,
              this.$router,
              this.$cookies,
              this.$store
            );
          })
          .catch(error => {
            this.$emit('onError', error);
          });
      },
      loadGoogleLibrary() {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://accounts.google.com/gsi/client';
          script.async = true;
          script.defer = true;
          script.onload = () => resolve();
          script.onerror = () => reject();
          document.head.appendChild(script);
        });
      },
    },
    data() {
      return {
        gisLoaded: false,
      };
    },
    mounted() {
      this.loadGoogleLibrary()
        .then(() => {
          this.gisLoaded = true;
          google.accounts.id.initialize({
            client_id: this.whitelabel.sso.googleClientId,
            callback: this.handleCredentialResponse,
          });
        })
        .catch(() => {
          console.error('Failed to load Google Identity Services library.');
        });
    },
  };
</script>
